/* eslint-disable no-plusplus, react/no-array-index-key, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { DEPTH_COLORS } from '../../constants/treeConstants';

const XMLNode = ({ node, depth, collapsed, onToggle, highlighted, onHighlight, classes, lineRef }) => {
  if (!node) return null;

  if (node.type === 'text') {
    lineRef.current++;
    return (
      <div className={classes.row}>
        <span className={classes.lineNumber}>{lineRef.current}</span>
        <span className={classes.nodeText} style={{ marginLeft: `${depth * 16}px` }}>
          {node.content}
        </span>
      </div>
    );
  }

  const hasChildren = node.children?.length > 0;
  const isCollapsed = collapsed[node.id];
  const isHighlighted = highlighted === node.tagName;
  const bgColor = DEPTH_COLORS[depth % DEPTH_COLORS.length];

  lineRef.current++;
  const openLine = lineRef.current;

  return (
    <div>
      <div
        className={`${classes.row} ${isHighlighted ? classes.rowHighlighted : ''}`}
        style={{ backgroundColor: isHighlighted ? undefined : bgColor }}
      >
        <span className={classes.lineNumber}>{openLine}</span>
        <div style={{ marginLeft: `${depth * 16}px` }} className={classes.nodeContainer}>
          {hasChildren ? (
            <span onClick={() => onToggle(node.id)} className={classes.collapseIcon}>
              {isCollapsed ? '▶' : '▼'}
            </span>
          ) : (
            <span className={classes.collapseIconPlaceholder} />
          )}
          <span onClick={() => onHighlight(node.tagName)} className={classes.nodeTag}>
            <span className={classes.tagBracket}>&lt;</span>
            <span className={classes.tagName}>{node.tagName}</span>
            {Object.entries(node.attributes).map(([key, value]) => (
              <span key={key}>
                <span className={classes.attrName}> {key}</span>
                <span className={classes.tagBracket}>=</span>
                <span className={classes.attrQuote}>&quot;</span>
                <span className={classes.attrValue}>{value}</span>
                <span className={classes.attrQuote}>&quot;</span>
              </span>
            ))}
            <span className={classes.tagBracket}>{hasChildren ? '>' : ' />'}</span>
          </span>
          {isCollapsed && hasChildren && (
            <span className={classes.collapsedBadge} onClick={() => onToggle(node.id)}>
              {node.children.filter((c) => c.type === 'element').length} children
            </span>
          )}
        </div>
      </div>

      {hasChildren && !isCollapsed && (
        <>
          {node.children.map((child, idx) => (
            <XMLNode
              key={idx}
              node={child}
              depth={depth + 1}
              collapsed={collapsed}
              onToggle={onToggle}
              highlighted={highlighted}
              onHighlight={onHighlight}
              classes={classes}
              lineRef={lineRef}
            />
          ))}
          {(() => {
            lineRef.current++;
            return (
              <div
                className={`${classes.row} ${isHighlighted ? classes.rowHighlighted : ''}`}
                style={{ backgroundColor: isHighlighted ? undefined : bgColor }}
              >
                <span className={classes.lineNumber}>{lineRef.current}</span>
                <div style={{ marginLeft: `${depth * 16}px` }} className={classes.nodeContainer}>
                  <span className={classes.collapseIconPlaceholder} />
                  <span onClick={() => onHighlight(node.tagName)} className={classes.nodeTag}>
                    <span className={classes.tagBracket}>&lt;/</span>
                    <span className={classes.tagName}>{node.tagName}</span>
                    <span className={classes.tagBracket}>&gt;</span>
                  </span>
                </div>
              </div>
            );
          })()}
        </>
      )}
    </div>
  );
};

XMLNode.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  node: PropTypes.object,
  depth: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  collapsed: PropTypes.object,
  onToggle: PropTypes.func,
  highlighted: PropTypes.string,
  onHighlight: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  lineRef: PropTypes.object,
};

XMLNode.defaultProps = {
  node: null,
  depth: 0,
  collapsed: {},
  onToggle: () => {},
  highlighted: null,
  onHighlight: () => {},
  classes: {},
  lineRef: { current: 0 },
};

export default XMLNode;
